/* eslint-disable func-names */
/* eslint-disable no-param-reassign */
(function handleStickyHeader() {
  let newScrollPosition = 0;
  let lastScrollPosition;
  const delta = 15;
  let scrollDistance = 200;
  const menuBreakpoint = window.matchMedia('(min-width: 1350px)');
  const header = document.querySelector('.header');
  const inPageNav = document.querySelector('#in-page-nav');
  const siteAlert = document.querySelector('.c-site-alerts');

  if (siteAlert) {
    document.body.classList.add('has-site-alert');
    scrollDistance = siteAlert.getBoundingClientRect().height + 40;
  } else {
    document.body.classList.add('no-site-alert');
  }

  window.addEventListener('scroll', function () {
    lastScrollPosition = window.scrollY;

    if (Math.abs(lastScrollPosition - newScrollPosition) <= delta) return;

    if (lastScrollPosition > scrollDistance) {
      header.classList.add('hide-header-top');
      if (siteAlert) {
        header.style.position = 'fixed';
        header.style.top = 0;
      }
    } else {
      header.classList.remove('hide-header-top');
      if (siteAlert) {
        header.style.position = 'relative';
      }
    }

    // Scrolling down
    if (newScrollPosition < lastScrollPosition && lastScrollPosition > scrollDistance) {
      header.classList.add('header-is-hidden');
      document.body.classList.remove('main-menu-shown');
      // Scrolling up
    } else if (newScrollPosition > lastScrollPosition) {
      if (inPageNav && lastScrollPosition > scrollDistance && menuBreakpoint.matches) return;
      header.classList.remove('header-is-hidden');
      document.body.classList.add('main-menu-shown');
    }

    newScrollPosition = lastScrollPosition;
  });
})();

(function siteAlertHover() {
  const links = document.querySelectorAll('.c-site-alerts a');

  if (!links.length > 0) return;

  links.forEach((link) => {
    const parent = link.closest('.c-site-alert');

    if (!parent) return;

    link.addEventListener('mouseover', () => {
      parent.style.backgroundColor = '#ffbf35';
    });

    link.addEventListener('mouseout', () => {
      parent.style.backgroundColor = '';
    });
  });
})();
